import { render, staticRenderFns } from "./NavAlignment.vue?vue&type=template&id=f57ff8f8&"
import script from "./NavAlignment.vue?vue&type=script&lang=js&"
export * from "./NavAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports